export default class Helper
{
	static unit = {
		millisecond     : 1000,
		second_in_day   : 86400,
		second_in_minute: 60,
		minute_in_hour  : 60,
		hour_in_day     : 24,
	}

	static string(value:any):string
	{
		return typeof value === 'string' || typeof value === 'number' ? String(value) : ''
	}
}
